/**
 * 首頁 /home 回應的 session 快取（依 context_id）。
 * 用來做 stale-while-revalidate：有快取先畫舊畫面，背景再靜默更新。
 */

const PREFIX = "lpg.homeCache.v1.";

export function homeCacheKey(contextId: string | number): string {
  return `${PREFIX}${contextId}`;
}

export function readHomeCache(contextId: string | number | null | undefined): unknown | null {
  if (contextId == null || contextId === "") return null;
  try {
    const raw = sessionStorage.getItem(homeCacheKey(contextId));
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function writeHomeCache(contextId: string | number | null | undefined, data: unknown): void {
  if (contextId == null || contextId === "" || data == null) return;
  try {
    sessionStorage.setItem(homeCacheKey(contextId), JSON.stringify(data));
  } catch {
    /* quota / private mode：略過 */
  }
}

export function clearHomeCache(contextId: string | number | null | undefined): void {
  if (contextId == null || contextId === "") return;
  try {
    sessionStorage.removeItem(homeCacheKey(contextId));
  } catch {
    /* silent */
  }
}
